module.exports = __webpack_public_path__ + "static/icon-8316bbe6f0f91037549c6f17dfdf1b88.png";